import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { MessageConstants } from 'src/app/constants/message-constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { DeviceService } from 'src/app/service/device.service';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { VehicleService } from 'src/app/service/vehicle.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-vehicle-summary',
  templateUrl: './vehicle-summary.component.html',
  styleUrls: ['./vehicle-summary.component.scss']
})
export class VehicleSummaryComponent implements OnInit, OnChanges {

  @Input() deviceData: any;
  @Output() linkToVehicleDeviceResponseEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() vehicleDeviceUnlinkedEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() deviceDataUpdateEmitter: EventEmitter<any> = new EventEmitter<any>();

  vehicleData: any;
  noDeviceVehicleMessage = Constants.NO_DEVICE_VEHICLE_MESSAGE;
  deviceVehicleUnlinkMessage = Constants.DEVICE_VEHICLE_UNLINK_MESSAGE;
  deviceVehicleLinkMessage = Constants.DEVICE_VEHICLE_LINK_MESSAGE;
  confirmDeleteVehicleHeader = "Unlink Device";
  confirmationModalAttributes: any;
  linkDeviceToVehicleModalAttributes: any;
  isVehicleLinked: boolean;
  // vehicleDataForUserVin: any;
  // invalidVinMessage: string;

  constructor(
    private deviceService: DeviceService,
    private vehicleService: VehicleService,
    private apiService: ApiService,
    private toastService: ToastService,
    private utilService: UtilService,
    private authService: AuthenticationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

    this.initIsVehicleLinked();

    if (this.isVehicleLinked) {
      this.getVehicleDetail(this.deviceData.vin);
    }

    this.initConfirmationModalAttributes();
    this.initlinkDeviceToVehicleModalAttributes();
  }

  ngOnInit(): void {
  }

  getVehicleLogo(vehicle): string {
    // return this.deviceService.getDeviceLogo(vehicle.devices[0]);
    return this.vehicleService.getVehicleLogo(vehicle);
  }

  getVehicleDetail(vin) {
    this.utilService.showSpinner();
    // this.invalidVinMessage = null;

    this.apiService.getVehicleDetails(vin).then((data) => {
      this.utilService.hideSpinner();
      console.log("Get vehicle detail from api : ", data);
      this.processVehicleDetails(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleDetail(vin);
        });
      } else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  processVehicleDetails(data: any) {
    this.vehicleData = data;
    /* if (this.isVehicleLinked) {
      this.vehicleData = data;
    } else {
      this.vehicleDataForUserVin = data;
    } */
    // this.initlinkDeviceToVehicleModalAttributes();
  }

  openConfirmUnlinkVehicleModal() {
    // document.getElementById("openDeleteVehicleConfirmation").click();
    document.getElementById(this.confirmationModalAttributes.modalOpenButtonId).click();
  }

  onConfirm(data) {

    // this.vehicleDeviceUnlinkedEmitter.emit(null);


    this.unlinkVehicleDevice();
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();

    /* if (modalName == 'confirmation-modal') {
      this.deleteAccountVehicleDevice();
      document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
    } */ /* else if (modalName == 'link-device-to-vehicle-modal') { */
    // this.linkDeviceToVehicle();
    // document.getElementById(this.linkDeviceToVehicleModalAttributes.modalCloseButtonId).click();
    // }
  }

  /* onCancel(data?) {
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
  }   */
  onCancel(data) {
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();

    /* if (modalName == 'confirmation-modal') {
      document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
    }  *//* else if (modalName == 'link-device-to-vehicle-modal') {

      // this.vehicleDataForUserVin = null;

      document.getElementById(this.linkDeviceToVehicleModalAttributes.modalCloseButtonId).click();
    } */
  }

  unlinkVehicleDevice() {
    this.utilService.showSpinner();
    this.apiService.unlinkVehicleDevice(this.deviceData.vin, this.deviceData.id).then((data) => {
      this.utilService.hideSpinner();
      console.log("unlink device response ::", data);
      this.toastService.showSuccess("device unlinked successfully");
      this.vehicleDeviceUnlinkedEmitter.emit(null);
      this.processVehicleDetails(null);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.unlinkVehicleDevice();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }
  /* unlinkVehicleDevice() {
      this.vehicleDeviceUnlinkedEmitter.emit(null);
      this.processVehicleDetails(null);
  } */

  initConfirmationModalAttributes() {
    this.confirmationModalAttributes = {
      "modalId": "confirmUnlinkDevice",
      "modalOpenButtonId": "openConfirmUnlinkDevice",
      "modalCloseButtonId": "closeConfirmUnlinkDevice",
      "modalHeader": this.confirmDeleteVehicleHeader,
      // "content": this.deviceVehicleUnlinkMessage
      // "content": "Confirm Unlink Device from the Vehicle " + this.deviceData.vin + " ?"
      "content": this.utilService.replaceTextInStatement(this.deviceVehicleUnlinkMessage, "<VIN#>", this.deviceData.vin)
    }
  }

  initlinkDeviceToVehicleModalAttributes() {
    this.linkDeviceToVehicleModalAttributes = {
      "modalId": "confirmLinkDeviceToVehicleModal",
      "modalOpenButtonId": "openConfirmLinkDeviceToVehicleModal",
      "modalCloseButtonId": "closeConfirmLinkDeviceToVehicleModal",
      "modalHeader": "Link Vehicle to Device",
      // "content": this.utilService.replaceTextInStatement(this.deviceVehicleLinkMessage, "<Device #>", this.deviceData.deviceSerialNumber),
      "content": this.deviceVehicleLinkMessage,
      "deviceData": this.deviceData,
      // "vehicleData": this.vehicleData
    }
  }

  openConfirmLinkVehicleModal() {

    // document.getElementById(this.linkDeviceToVehicleModalAttributes.modalOpenButtonId).click();
  }

  // linkDeviceToVehicle() {

  //   // this.addAccountVehicleDevice();

  //   // var requestPayload = this.getVehicleDeviceProvisioningPayload();
  // }

  openLinkDeviceToVehicleModal() {

    document.getElementById(this.linkDeviceToVehicleModalAttributes.modalOpenButtonId).click();

  }

  /* getVehicleData(data) {
    // this.deviceData.vin = data;
    this.getVehicleDetail(data);
  }
 */
  initIsVehicleLinked() {
    if (this.deviceData.vin)
      this.isVehicleLinked = true;
    else
      this.isVehicleLinked = false;
  }

  // getVehicleDeviceProvisioningPayload() {
  //   return {
  //     "type": "VEHICLE",
  //     "provisioningData": {
  //       "enterpriseId": this.authService.loggedInUser.enterpriseId,
  //       "accountId": !isNullOrUndefined(this.vehicleDataForUserVin.accountId) ? this.vehicleDataForUserVin.accountId : this.utilService.selectedRentalFleetAccount.id,
  //       "vin": this.vehicleDataForUserVin.vin,
  //       "make": this.vehicleDataForUserVin.make.toUpperCase(),
  //       "model": this.vehicleDataForUserVin.model.toUpperCase(),
  //       "year": this.vehicleDataForUserVin.year,
  //       "color": this.vehicleDataForUserVin.color,
  //       "status": this.vehicleDataForUserVin.status,
  //       "devices": [this.deviceData]
  //     }
  //   };
  // }

  // addAccountVehicleDevice() {
  //   var requestPayload = this.getVehicleDeviceProvisioningPayload();
  //   console.log("device request payload::", requestPayload);
  //   this.utilService.showSpinner();
  //   this.apiService.provision(requestPayload).then((data) => {
  //     this.utilService.hideSpinner();
  //     console.log("add vehicle device response ::", data);
  //     this.toastService.showSuccess(MessageConstants.DEVICE_ADDED);
  //     // this.resetAddVehicleDeviceForm();
  //     // document.getElementById("closeAddVehicleDevice").click();
  //     // this.saveEmitter.emit();
  //   }).catch((error) => {
  //     console.log("err : ", error);
  //     if (error.status == Constants.HTTP_UNAUTHORISED) {
  //       this.authService.refreshToken().then(() => {
  //         this.utilService.hideSpinner();
  //         console.log("refresh token api executed");
  //         this.addAccountVehicleDevice();
  //       });
  //     }
  //     else {
  //       this.utilService.hideSpinner();
  //       if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
  //       else this.toastService.showError(Constants.UNKNOWN_ERROR);
  //     }
  //   });
  // }

  processAddAccountVehicleDeviceResponse(responseData) {

    let vehicleData = responseData.data;
    this.processVehicleDetails(vehicleData);

    let responseDevices = responseData.data.devices.filter(
      (device) => device.id == this.deviceData.id
    );
    let responseDevice = responseDevices[0];

    // responseDevice["dongleStatus"] = "LINKED";
    this.linkToVehicleDeviceResponseEmitter.emit(responseDevice);

  }

  onlinktoVehicleSuccess(data) {

    if (data.vin) {
      this.getVehicleDetail(data.vin);
    }
    this.deviceDataUpdateEmitter.emit(data);
  }
}
